import React from "react";
import CommonHeader from "../components/common/CommonHeader";
import CommonFooter from "../components/common/CommonFooter";
import teamImage1 from "../assets/team_member_1.png"; 
import teamImage2 from "../assets/team_member_2.png";
import teamImage3 from "../assets/team_member_3.png";
import leftImg from "../assets/team_page_image_left.png";
import rightImg from "../assets/team_page_image_right.png";

const TeamPage = () => {
  const teamMembers = [
    {
      id: 1,
      image: teamImage1,
      name: "NON EXEC. DIR. | MATAR KITBI",
      designation: "President and CEO",
    },
    {
      id: 2,
      image: teamImage2,
      name: "FOUNDER | RASHED AL AMERI",
      designation: "Chief Operations Officer",
    },
  ];

  return (
    <div style={{ background: "#F7F7F7", minHeight: "100vh" }}>
      <CommonHeader bgColor="#DDC7BB" />

      {/* Section 1 - Team Content */}
      <div style={{ padding: "60px 20px", textAlign: "center" }}>
        <h1
          style={{
            fontFamily: "Alike Angular",
            fontSize: "2.5rem",
            marginBottom: "30px",
            color: "#000",
          }}
        >
          Dedicated And Experienced Leadership
        </h1>
        <p
          style={{
            fontSize: "1.3rem",
            lineHeight: "1.6",
            color: "#333",
            maxWidth: "800px",
            margin: "0 auto 40px auto",
            fontFamily: "Alike Angular",
          }}
        >
          Our leadership team brings together a remarkable depth and breadth of
          experience. Each of us is dedicated to supporting and serving our
          clients.
        </p>

        {/* Team Members Grid */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            flexWrap: "wrap",
            marginBottom: "60px",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {teamMembers.map((member) => (
            <div
              key={member.id}
              style={{
                textAlign: "center",
                maxWidth: "300px",
                flex: "1",
                minWidth: "250px",
              }}
            >
              <img
                src={member.image}
                alt={member.name}
                style={{
                  width: "100%",
                  height: "350px",
                  objectFit: "cover",
                  marginBottom: "20px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              />
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "normal",
                  marginBottom: "8px",
                  color: "#000",
                  fontFamily: "Alike Angular",
                }}
              >
                {member.name}
              </h3>
            </div>
          ))}
        </div>

        {/* Quote Section */}
        <div
          style={{
            background: "#001731",
            padding: "70px 20px",
            color: "#fff",
            margin: "60px auto",
          }}
        >
          <div
            style={{
              border: "1px solid rgba(224, 224, 224, 0.4)",
              padding: "50px",
              maxWidth: "900px",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // Center the content block horizontally
            }}
          >
            <div
              style={{
                maxWidth: "600px", // Constrain the text width for better centering
                width: "100%",
                textAlign: "left", // Left align text within this constrained container
              }}
            >
              <p
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8",
                  fontStyle: "italic",
                  marginBottom: "30px",
                  textAlign: "left",
                  fontFamily: "Alike Angular",
                }}
              >
                "Lasting success is built only on promises kept and your word is
                your legacy."
              </p>

              <p
                style={{
                  fontWeight: "normal",
                  marginBottom: "5px",
                  textAlign: "left",
                  color: "#8A8383",
                }}
              >
                RASHED AL AMERI
              </p>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <h2 style={{ fontSize: "1.8rem", marginBottom: "40px", color: "#000" }}>
          Let's get in touch.
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            flexWrap: "wrap",
            marginBottom: "80px",
          }}
        >
          {/* Card 1 */}
          <div style={{ textAlign: "center", maxWidth: "300px" }}>
            <img
              src={leftImg}
              alt="Real estate professional"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "6px",
                marginBottom: "15px",
              }}
            />
            <p
              style={{
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#333",
              }}
            >
              Are you a real estate professional
            </p>
            <a
              href="/contact-us"
              style={{
                fontSize: "0.85rem",
                color: "#072D4B",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              JOIN US →
            </a>
          </div>

          {/* Card 2 */}
          <div style={{ textAlign: "center", maxWidth: "300px" }}>
            <img
              src={rightImg}
              alt="Sell property"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "6px",
                marginBottom: "15px",
              }}
            />
            <p
              style={{
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#333",
              }}
            >
              Are you looking to sell your property?
            </p>
            <a
              href="/policy"
              style={{
                fontSize: "0.85rem",
                color: "#072D4B",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              SELL WITH US →
            </a>
          </div>
        </div>
      </div>

      <CommonFooter />
    </div>
  );
};

export default TeamPage;
